module.exports = __webpack_public_path__ + "static/media/foreman.f10a25eb.svg";